import { Misc, Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { AppService, DomainTypes } from "../../../DomainTypes";
import CostRecoveryPremium from "../../../Models/Catalogue/Pipeline/CostRecoveryPremium";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class CostRecoveryPremiumCatalogueEntry extends CatalogueEntry<CostRecoveryPremium> {

    private pipelinesApiClient = AppService.get(DomainTypes.ApiClients.CataloguePipeline);

    constructor() {
        super("Cost Recovery Premiums", CostRecoveryPremium);
    }

    public get editRole() {
        return CatalogueRoles.CostRecoveryPremiums.Edit;
    }

    public getFetchEndpoint(apiClient: IGenericApiClient) {
        return this.pipelinesApiClient.getCostRecoveryPremiums;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return this.pipelinesApiClient.saveCostRecoveryPremiums;
    }

    public renderRow(item: CostRecoveryPremium, meta: Model.TransformMetaType<CostRecoveryPremium>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.costRecoveryPremiumValue}
                                numProps={{ format: Misc.NumberFormat.Decimals }}
                                alignment="center"/>
                <NeoGrid.Column bind={meta.premiumStartDate} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}